// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var JsxRuntime = require("react/jsx-runtime");
var Role$ReactHooksTemplate = require("./role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");

function RoleListItem(props) {
  var role = props.role;
  var capabilities = Role$ReactHooksTemplate.enabledCapabilities(role);
  var match = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match[0];
  return JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("td", {
                      children: Role$ReactHooksTemplate.name(role),
                      className: "py-10-px pl-4 w-1/6"
                    }),
                JsxRuntime.jsx("td", {
                      children: Role$ReactHooksTemplate.description(role),
                      className: "py-10-px pl-4 w-1/6"
                    }),
                JsxRuntime.jsx("td", {
                      children: $$Array.of_list(List.map((function (capability) {
                                  return JsxRuntime.jsx("p", {
                                              children: capability,
                                              className: "w-1/8 text-xs border border-gray-300 rounded-full px-3 py-1 m-1 bg-white text-gray-800"
                                            }, capability);
                                }), capabilities)),
                      className: "flex flex-wrap py-20-px pl-7"
                    }),
                JsxRuntime.jsx("td", {
                      children: Role$ReactHooksTemplate.createdAt(role).fromNow(false),
                      className: "p-12-px w-1/6"
                    }),
                JsxRuntime.jsx("td", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              Curry._1(hasPermission, "UpdateRole") ? JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx("img", {
                                              className: "h-4 w-4",
                                              src: Image$ReactHooksTemplate.edit
                                            }),
                                        "Edit"
                                      ],
                                      className: "flex items-center gap-2 px-4 py-2 border border-gray-300 hover:border-teal-500 hover:text-teal-600 rounded",
                                      onClick: props.handleEdit
                                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                              Curry._1(hasPermission, "DeleteRole") ? JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx("img", {
                                              className: "h-4 w-4",
                                              src: Image$ReactHooksTemplate.trash
                                            }),
                                        "Delete"
                                      ],
                                      className: "flex items-center gap-2 text-white bg-red-600 hover:bg-red-700 px-4 py-2 border border-red-700 rounded",
                                      onClick: props.handleDelete
                                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                            ],
                            className: "flex gap-4"
                          }),
                      className: "p-12-px w-1/6"
                    })
              ],
              className: "hover:bg-gray-200 hover:shadow-md border-b"
            }, String(Role$ReactHooksTemplate.id(role)));
}

var make = RoleListItem;

exports.make = make;
/* react Not a pure module */
